// extracted by mini-css-extract-plugin
module.exports = {"fieldset":"FloatingColorPicker_fieldset__ZdgQT"};